import * as React from "react";
import { VeboxExpandable } from "../../../../../components/expadable/VeboxExpandable";
import "./styles.scss";

type FindEquipmentAdditionalFilterProps = {
	name: string;
	active: boolean;
	open: boolean;
	openIfActive: boolean;
};

export const FindEquipmentAdditionalFilter: React.FC<
	FindEquipmentAdditionalFilterProps
> = (props) => {
	const head = (state, setState) => {
		const toggle = () => setState(!state);
		return (
			<div
				onClick={toggle}
				className={"filter-title-container flex flx-align-center "}
			>
				<div
					className={
						"filterGroupArrow " + (state ? "filterGroupArrowDown" : "")
					}
					style={{ filter: "none" }}
				/>
				<p
					className={
						"additional-filter-title " +
						(props.active ? "additional-active" : "additional-not-active")
					}
				>
					{props.name}
				</p>
			</div>
		);
	};
	return (
		<div className={`additional-filter-container`}>
			<VeboxExpandable
				collapsed={head}
				expanded={props.openIfActive ? props.open : false}
			>
				<div className={"additional-filter-section"}>{props.children}</div>
			</VeboxExpandable>
		</div>
	);
};
